// This file is AUTOGENERATED, do not edit it manually!!!

export const commonClient = {
    all_projects_label: 'Tutti i progetti',
    archive_action_text: 'Archiviare',
    Cancel: 'Annullare',
    completeActivityConfirm: 'Si è specificato che l\'attività è stata completata al 100%. Completare l\'attività? Premere \'OK\' per cambiare lo status, \'Annulla\' altrimenti.',
    completeProjectConfirm: 'Si è specificato che il progetto è stato completato al 100%. Si desidera completare il progetto? Premere \'OK\' per cambiare lo status.',
    confirmCompleteActivityParents: 'Il completamento di questa sub-attività non lascerà aperte quelle sotto l\'attività principale. Vuoi l\'attività principale come completata?  i noti che se non sono rimaste attività aperte nel  progetto questo verrà ugualmente segnato come completato.',
    Duplicate: 'Duplicare',
    Edit: 'Modificare',
    Entity_Category: 'Categoria',
    Entity_Customer: 'Cliente',
    Entity_Priority: 'Priorità',
    Entity_Project: 'Progetto',
    Entity_Task: 'Compito',
    Entity_User: 'Utente',
    Error_CantFindObjectTemplate: 'Impossibile completare l\'operazione per i seguenti motivi: impossibile trovare l\'oggetto (tipo: {entityName}, ID: {objectKey}) nel database.  Ciò può accadere a causa di rimozioni o mancanza di permessi per visualizzare l\'oggetto. Consultare l\'amministratore di {brandName} per individuare le cause possibili.',
    HourPluralFormatTemplate: '1#{0} Ora#{0} Ore',
    HyperLinkTooltip: 'Per visitare il collegamento, fare clic tenendo premuto CTRL',
    OperationError_Title: 'Impossibile completare l\'operazione',
    type: 'Tipo',
};
